import React from "react";
import { Button } from "@mui/material";

const MuiButton = (props) => {
  return (
    <Button
      type={props.type}
      color={props.color}
      variant="contained"
      style={{ display: props.show ? "block" : "none" }}
      onClick={props.onClick}
    >
      {props.text}
    </Button>
  );
};

export default MuiButton;
